export default __webpack_public_path__ + "static/media/plusWelcome.88be3c5b.png";